import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableSortLabel,Checkbox,Tooltip,IconButton,Dialog} from "@material-ui/core"
import React, { useState, Fragment } from "react";
import ConfirmDialog from "./ConfirmDialog";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { AdTableMainHead ,smbcMainHead} from "../containers/AdTableHead"
import { getLocalStorageInfo } from "../../../../utils"
import config from "../../../../config"
import { permissionCheckFnforCamo } from "../../../../utils";
import { smbcInstance } from "../../../../shared_elements/components";
const AdTable = ({ bulkOperation,bulkFlag,heads, noRecord, data, sort = "", sort_by = "", pagination = {}, onChangePage, onChangeRowsPerPage, createSortHandler, currentRecordPerPage,toggleBulkOps,bulkDeletefn ,basicDetails,assetType, isBasicDetailExpanded}) => {
	const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
  const smbcMainHeads = !permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D"}) || window?.location?.search.includes('archived-assets') ? smbcMainHead.filter(item=>item.id !=1) : assetType ? smbcMainHead.filter(item=>item.id !=1) : smbcMainHead
  const AdTableMainHeads = window?.location?.search.includes('archived-assets') ? AdTableMainHead.filter(item=>item.id !=1) : AdTableMainHead
	return (
		<Fragment>
			<div id="AmpTable" style={{ height: `${window.innerHeight - (isBasicDetailExpanded ? 475 : 295)}px`, overflow: 'auto' }}>
				<Table className="table-wrapper" id={"smbc_ad"}>
					{/* <Table className="table-wrapper" id={ smbcInstance ? "smbc_ad" : "ad"}> */}
					<TableHead>
						<TableRow>
							{/* {( smbcInstance ? smbcMainHeads : AdTableMainHeads).map((row, index) => ( */}
							 {(smbcMainHeads).map((row, index) => (
								<TableCell colSpan={row.colspan} align="center" key={index}>
									{row.label}
								</TableCell>
							))}
						</TableRow>
						<TableRow>
						{!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D"}) || window?.location?.search.includes('archived-assets') ? null : bulkOperation ? (
                                <TableCell>
                                    <Checkbox
                                        size="small"
                                        checked={bulkFlag}
                                        onChange={(e) => toggleBulkOps(e.target.checked)}
                                        name="bulk_operation"
                                        color="primary"
                                    />
                                    {bulkOperation?.ids?.length > 0 && <Tooltip title="Delete" arrow placement="top">
                                        <IconButton className="delete-icon" >
                                            <DeleteOutlinedIcon onClick={handleClick} /><span style={{fontSize:'14px'}}>({bulkOperation?.ids?.length})</span>
                                        </IconButton>
                                    </Tooltip>}
                                </TableCell>
                            ) : null}
							{heads.map((row, index) => (
								<TableCell
									key={index}
									align={row.actionCell ? "right" : "left"}
									padding={"normal"}
									sortDirection={sort === row.id ? (sort_by ? sort_by : "asc") : false}
								>
									{row.sortOption && noRecord === null ? (
										<TableSortLabel
											active={sort === row.id}
											direction={sort === row.id ? sort_by : "asc"}
											onClick={() => createSortHandler(row.id)}
										>
											{row.label}
										</TableSortLabel>
									) : (
										<span>{row.label}</span>
									)}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{noRecord ? (
							<TableRow id="table-no-records">
								<TableCell
									colSpan={bulkOperation ? heads.length + 1 : heads.length}
									align="center"
								>
									{noRecord}
								</TableCell>
							</TableRow>
						) : (
							data
						)}
					</TableBody>
				</Table>
			</div>
			{Object.keys(pagination).length && pagination.total > 0 ? (
				<TablePagination
					rowsPerPageOptions={bulkFlag ? [] : [100, 150, 200, 250]}
					component="div"
					count={pagination.total}
					rowsPerPage={bulkFlag ? pagination.total : currentRecordPerPage}
					page={pagination.page - 1}
					backIconButtonProps={{ "aria-label": "previous page" }}
					nextIconButtonProps={{ "aria-label": "next page" }}
					onChangePage={onChangePage}
					onChangeRowsPerPage={onChangeRowsPerPage}
					showFirstButton={true}
					showLastButton={true}
				/>
			) : null}
			  <Dialog open={open} onClose={handleClose} id="htDialog">
                <ConfirmDialog
                    handleClose={() => handleClose()}
                    handleDeleteRow={bulkDeletefn}
                    title={bulkOperation?.type === "bulk" ? "Do you really want to delete all the records?" :"Do you really want to delete selected records?"}

                />
            </Dialog>
		</Fragment>
	)
}

export default AdTable
